import Controller from "./invoices.controller";
import template from "./invoices.html";

const invoices = {
  template,
  controller: Controller,
};

export default invoices;



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices.component.js